export default __webpack_public_path__ + "static/media/ticket39.1511ef54.jpg";